"use strict";
import {http} from '../../core'
const RequestService = http.create()
import Config from "../../app.config";
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {

    // sla
    // 新增sla
    serviceSlaAdd: function serviceSlaAdd(params) {
        return RequestService.post('service/sla/add', params)
    },
    // 编辑sla
    serviceSlaEdit: function serviceSlaEdit(params) {
        return RequestService.post('service/sla/edit', params)
    },
     // sla列表
    serviceSlaList: function serviceSlaList(params) {
        return RequestService.get('service/sla/list', params)
    },
     // 删除sla
    serviceSlaDelete: function serviceSlaDelete(params) {
        return RequestService.post('service/sla/delete', params)
    },
    // sla详细
    serviceSlaDescribe: function serviceSlaDescribe(params) { 
        return RequestService.get('service/sla/describe', params)
    },

    // 服务
    // 新增服务
    serviceAdd: function serviceAdd(params) {
        return RequestService.post('service/add', params)
    },
    // 编辑服务
    serviceEdit: function serviceEdit(params) {
        return RequestService.post('service/edit', params)
    },
    // 删除服务
    serviceDelete: function serviceDelete(params) {
        return RequestService.post('service/delete', params)
    },
    // 服务列表
    serviceList: function serviceList(params) {
        return RequestService.get('service/list', params)
    },

    // 团队
    // 团队列表
    serviceTeamList: function serviceTeamList(params) {
        return RequestService.get('service/team/list', params)
    },
    // 团队人列表
    serviceTeamUserList: function serviceTeamUserList(params) {
        return RequestService.get('service/team/user/list', params)
    },

    // 合同
    // 新增合同
    contractAdd: function contractAdd(params) {
        return RequestService.post('service/contract/add', params)
    },
    // 编辑合同
    contractEdit: function contractEdit(params) {
        return RequestService.post('service/contract/edit', params)
    },
     // 删除合同
    contractDelete: function contractDelete(params) {
        return RequestService.post('service/contract/delete', params)
    },
     // 合同列表---旧
    contractList: function contractList(params) {
        return RequestService.get('service/contract/list', params)
    },
    // 合同列表--新
    contractSearch: function contractSearch(params) {
        return RequestService.get('service/contract/search', params)
    },
    // 合同详细
    contractDescribe: function contractDescribe(params) {
        return RequestService.get('service/contract/describe', params)
    },

    // 字典
    dataDictionary: function dataDictionary(params) {
        return RequestService.get('data/dictionary', params)
    },

    // 服务方
    // 获取部门树顶级节点
    treeTop: function treeTop(params) {
        return RequestService.get('organization/department/tree/top', params)
    },
    treeChildren: function treeChildren(params) {
        return RequestbaseURL.get('itsm/v2/organization/department/tree/children', params)
    },
    // 获取树节点用户
    treeUser: function treeUser(params) { 
        return RequestService.get('organization/department/tree/user', params)
    },

    // 获取公司接口
    companyList: function companyList(params) { 
        return RequestService.get('organization/company/list', params)
    },
    // 获取用户组用户
    groupUser: function groupUser(params) { 
        return RequestbaseURL.post('itsm/v2/organization/user/group_user', params)
    },
    // 获取部门用户
    departmentUser: function departmentUser(params) {
        return RequestbaseURL.get('itsm/v2/organization/user/department_user', params)
    }
}
